module.exports = __webpack_public_path__ + "static/media/iphone_14_starlight.c4badb05.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_starlight.jpeg
// module id = 2177
// module chunks = 0